// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"628":"95a2191f","925":"7d209919"}[chunkId] + ".chunk.css";
};